import r from"./arrayLikeToArray.js";function a(a){if(Array.isArray(a))return r(a)}export default a;
//# sourceMappingURL=arrayWithoutHoles.js.map
